define(["jquery",
        "wcs.context"],
    function ($, ctx) {

        var DEBUG = false;
        var $deferred = new $.Deferred();

        var that = {};
        var availabilityUrl, storeId, langId, productId;

        that.init = function () {
            availabilityUrl = $('meta[property="og:availability:url"]').attr("content");
            storeId =  $('meta[name=storeId]').attr("content");
            langId = $('meta[name=langId]').attr("content");
            productId =  $('meta[property="og:productId"]').attr("content");
        };

        that.getAvailabilities = function () {

            if (DEBUG) console.log('getAvailabilities');

            return $.ajax({
                url: ctx.getURLWithContextRoot(availabilityUrl),
                data: {
                    storeId: storeId,
                    langId: langId,
                    productId: productId
                }
            });
        };

        that.init();
        if( !productId ){
            $deferred.reject();
        }
        else{
            return that.getAvailabilities();
        }
        return $deferred.promise();
    }
);
